export default __webpack_public_path__ + "static/wind-03-2-335a924f1350908fc15610b4781699e8.jpg";